let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4yBEc")).then(() => parcelRequire('dOFQj'));